import { Button } from '@Components/Buttons';
import { Header, Text } from '@Components/Text';
import styled from 'styled-components';

export const TitleLogin = styled(Header).attrs({
	variant: 'h1',
	weight: 'bold',
})`
	margin-bottom: 1.5rem;
	max-width: 27.571rem;
`;

export const StyledLink = styled(Text).attrs({
	weight: 'bold',
})`
	margin-bottom: 0px;
	color: #0095e8;
	:hover {
		color: #009ef7;
	}
`;

export const HeaderLink = styled(Text).attrs({
	variant: 'h5',
	weight: 'bold',
})`
	margin-bottom: 0px;
	color: #0095e8;
	:hover {
		color: #009ef7;
	}
`;

export const HeaderText = styled(Text).attrs({
	variant: 'h5',
	weight: 'semi-bold',
})`
	margin-bottom: 0px;
	color: #5e627899;
	margin-right: 10px;
`;

export const ContainerGoogle = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
`;

export const TextButtonGoogle = styled(Header).attrs({
	weight: 'bold',
	variant: 'h5',
})`
	display: flex;
	align-items: center;
	color: #5e6278;
	margin-bottom: 0px;
`;

export const ButtonGoogle = styled(Button)`
	flex: 1;
	gap: 10px;
`;

export const TextLogin = styled(Header).attrs({
	weight: 'bold',
	variant: 'h5',
})`
	display: flex;
	justify-content: center;
	align-items: center;
	color: #ffffff;
	margin-bottom: 0px;
`;

export const ContainerBtnLogin = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;
